const LABEL_TAG_ENUMS = {
  LABEL: "label",
  LEGEND: "legend"
};
export {
  LABEL_TAG_ENUMS
};
//# sourceMappingURL=constants.mjs.map
